<template>
  <span v-if="timeStr === '00:00:00'">待开播</span>
  <span v-else> {{ timeStr }}</span>
</template>

<script>
import moment from "moment";
import { transTimestamp } from "../utils/tool";

export default {
  props: {
    endTime: String,
    startTime: String,
  },
  data() {
    return {
      timeStr: "",
      timer: null,
      tagTime: 1,
    };
  },
  mounted() {
    // console.log(this.startTime);
    this.timer = setInterval(() => {
      if (this.startTime) {
        this.getResTime(this.startTime);
      }
    }, 1000);
  },
  methods: {
    getResTime(time) {
      let t = +new Date(time);
      let now = +new Date();
      let day = 24 * 60 * 60 * 1000;
      let resTime = t - now; //剩余时间
      // let that = this
      if (resTime > day) {
        // 大于一天
        var a = Math.floor(resTime / day);
        this.timeStr = "距开播剩" + a + "天";
      } else {
        //小于一天
        let h = Math.floor((resTime / (1000 * 60 * 60)) % 24);
        let m = Math.floor((resTime / (1000 * 60)) % 60);
        let s = Math.floor((resTime / 1000) % 60);
        if (h >= 0) {
          if (h < 10) {
            h = "0" + h;
          }
          if (m < 10) {
            m = "0" + m;
          }
          if (s < 10) {
            s = "0" + s;
          }
          this.timeStr = h + ":" + m + ":" + s + "后开播";
        } else {
          clearInterval(this.timer);
          this.timeStr = "00:00:00";
        }
      }
      // console.log(time, t, resTime, '44');
    },
    transTimestamp(datetime, dateSeprator = "-", timeSeprator = ":") {
      if (datetime) {
        let time = new Date(datetime);
        let year = time.getFullYear() + ""; //返回当前年份        2022    2022年
        let month = time.getMonth() + 1 + ""; //返回当前月份        3       4月
        let date = time.getDate() + "";
        let hour = time.getHours() + ""; //返回时（0-23）      10      10时
        let minutes = time.getMinutes() + ""; //返回分（0-59）      6       六分
        let seconds = time.getSeconds() + ""; //返回秒（0-59）      32      32秒
        let millseconds = time.getMilliseconds() + "";

        if (month.length === 1) {
          month = `0${month}`;
        }
        if (date.length === 1) {
          date = `0${date}`;
        }
        if (hour.length === 1) {
          hour = `0${hour}`;
        }
        if (minutes.length === 1) {
          minutes = `0${minutes}`;
        }
        if (seconds.length === 1) {
          seconds = `0${seconds}`;
        }
        return `${year}${dateSeprator}${month}${dateSeprator}${date} ${hour}:${minutes}`;
      }
    },
  },
};
</script>
